{
    "Accessibility": {
        "SvgTitle": {
            "agentIndicator": "Indicatore agente",
            "botIndicator": "Indicatore bot",
            "chatIcon": "Icona chat",
            "checkboxIcon": "Icona casella di controllo",
            "chevronDown": "Chevron verso il basso",
            "chevronRight": "Chevron verso destra",
            "clockIcon": "Icona orologio",
            "closeIcon": "Icona chiudi",
            "endChatIcon": "Icona termina chat",
            "feedbackIcon": "Icona feedback",
            "menuIcon": "Icona menu",
            "muteIcon": "Icona disattiva audio",
            "newMessageIcon": "Icona nuovo messaggio",
            "radioIcon": "Icona pulsante radio",
            "ratingStarIcon": "Icona stella di valutazione",
            "receiptIcon": "Icona ricevuta",
            "ringIcon": "Icona Ring",
            "sendIcon": "Icona invia",
            "themeIcon": "Icona tema",
            "thumbsDownIcon": "Icona pollice in giù",
            "thumbsUpIcon": "Icona pollice in su",
            "unmuteIcon": "Icona attiva audio",
            "userIcon": "Icona utente"
        }
    },
    "Components": {
        "Alert": {
            "ariaLabel": "Chiudi",
            "endChatError": "Impossibile terminare la sessione. Riprova.",
            "sessionEnded": "La sessione è terminata. Sei stato reindirizzato alla pagina iniziale.",
            "networkError": "Si è verificato un problema di connessione della sessione. Riprova",
            "messageError": "Siamo spiacenti, la nostra chat di assistenza al momento non è disponibile. Usa la <a href='https://ring.com/support'>Guida Ring</a> per trovare aiuto o riprova tra qualche minuto.",
            "messageLabel": "allerta",
            "pendingTimeout": "Siamo spiacenti, il nostro assistente sta rispondendo più lentamente di quanto previsto. Per favore, riprova o riformula la tua domanda."
        },
        "Body": {
            "latestMessage": "Ultimi messaggi",
            "loadMessages": "Carica messaggi",
            "newMessage": "Nuovo messaggio",
            "title": "Come possiamo aiutarti?",
            "subtitle": "Salve! Sono l'assistente del Servizio assistenza clienti di Ring. Come posso aiutarti oggi?"
        },
        "Bubble": {
            "ariaLabel": "messaggio di chat",
            "sourceTitle": "Collegamenti utili"
        },
        "Entry": {
            "reasoningAriaLabel": "Pensando",
            "reasonings": {
                "thinkingText": "Pensando"
            }
        },
        "Event": {
            "defaultJoin": "Un membro del team Ring è entrato nella chat dal vivo.",
            "customerJoin": "Effettuato trasferimento alla chat dal vivo.",
            "agentJoin": "è entrato nella chat dal vivo.",
            "defaultLeft": "Il membro del team Ring ha lasciato la chat dal vivo.",
            "customerLeft": "Hai lasciato la chat.",
            "agentLeft": "ha lasciato la chat dal vivo.",
            "idle": "Sei rimasto inattivo per un po'. Facci sapere come possiamo aiutarti!",
            "idleContinue": "Sono ancora qui, ho bisogno di più tempo",
            "idleEnd": "Termina chat",
            "returned": "Bentornato! Continuiamo la conversazione."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Pollice su",
            "ariaLabelThumbsDown": "Pollice giù",
            "header": "È stato utile?",
            "sent": "Grazie per il tuo feedback",
            "thumbsDown": "Mi scuso se la mia risposta non è stata soddisfacente. Mi piacerebbe ricevere il tuo feedback per migliorare.",
            "thumbsDownResponse": "Grazie per il tuo feedback. Prova a riformulare la domanda per cortesia.",
            "thumbsUp": "Sono felice che ti abbia aiutato! Non esitare a contattarmi per qualsiasi altra informazione.",
            "RESPONSE_UNCLEAR": "Risposta non chiara",
            "ISSUE_UNRESOLVED": "Non ho risolto il mio problema",
            "NOT_HELPFUL": "Non utile"
        },
        "Footer": {
            "ariaLabel": "Invia",
            "placeholder": "Poni una breve domanda...",
            "botText": "Questo chatbot utilizza l'intelligenza artificiale generativa per rispondere alle tue domande. Si prega di verificare qualsiasi informazione importante fornita in queste risposte prima di agire di conseguenza."
        },
        "Header": {
            "ariaLabelMenu": "Menu altro",
            "ariaLabelMinimize": "Riduci a icona",
            "badgeTitle": "BETA",
            "badgeDisabled": "Disconnesso",
            "themeLabel": "Tema",
            "muteLabel": "Silenzia",
            "unmuteLabel": "Desilenzia",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Chiusora chat"
        },
        "NotificationCard": {
            "ariaLabelClose": "Chiudi",
            "ariaLabelOpen": "Aperta",
            "notification": "Nuovo messaggio",
            "expand": "Clicca per espandere"
        },
        "WidgetIcon": {
            "ariaLabel": "Chatta per ricevere supporto"
        },
        "WelcomeScreen": {
            "ariaLabel": "Riduci a icona",
            "button": "Avvia chat",
            "title": "Grazie per aver contattato Ring",
            "subtitleHtml": "Continuando, accetti i <a href='https://ring.com/terms'>Termini di servizio Ring</a>. Le informazioni relative a questa chat possono essere raccolte e registrate. Per ulteriori informazioni, consulta la nostra <a href='https://ring.com/privacy-notice'>Informativa sulla privacy</a>.",
            "loading": "Avvio chat...",
            "error": "Impossibile avviare la sessione. Riprova",
            "messageLabel": "testo di benvenuto"
        }
    }
}